import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EProductBrandSortField,
  IProductBrand,
  PProductBrandFilter,
} from "src/core/productBrand/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IProductBrandState {
  productBrands: IProductBrand[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IProductBrandState = {
  productBrands: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "product-brand/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "product-brand/FETCH_SUCCEEDED";
const FETCH_FAILED = "product-brand/FETCH_FAILED";
const POLLING_START_REQUESTED = "product-brand/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "product-brand/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IProductBrand[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PProductBrandFilter;
    pagination: IPagination;
    sorts: ISort<EProductBrandSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IProductBrandState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IProductBrandState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.productBrands = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
